<template>
    <div class="">

        <p>
            <em>This price will be before any petrol costs or other expenses (determined below)</em>
        </p>

        <div class="form-group mb-4">
            <label>
                <strong>
                    Calculation
                </strong>
            </label>
            <div class="pricecalculation">

                <div v-if="rate !== null ">

                    <div class="form-group">

                        <table class="table jobprice">

                            <tbody>
                                <tr v-for="rateInfo in rate_information" :key="rateInfo.id">
                                    <td>{{ rateInfo[0] }}</td>
                                    <td>£{{ rateInfo[1] }}</td>
                                </tr>
                            </tbody>

                            <tfoot>
                            <tr>
                                <td>
                                    <strong>
                                        Total
                                    </strong>
                                </td>
                                <td>
                                    <strong>
                                        £{{ rate.total }}
                                    </strong>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                    </div>

                </div>

                <div v-else >
                    <p class="mb-0">
                        Please enter the details below to generate a price
                    </p>

                    <p
                        class="text-white mb-0 mt-2 bg-danger py-2 px-4 rounded-2"
                        v-if="internalContractId === null"
                    >
                        <strong>
                            Please select a contract
                        </strong>
                    </p>
                    <p
                        class="text-white mb-0 mt-2 bg-danger py-2 px-4 rounded-2"
                        v-if="internalVehicleId === null"
                    >
                        <strong>
                            Please select a vehicle
                        </strong>
                    </p>
                    <p
                        class="text-white mb-0 mt-2 bg-danger py-2 px-4 rounded-2"
                        v-if="internalMileage === 0"
                    >
                        <strong>
                            Please enter a Collection or Delivery address to compute a mileage
                        </strong>
                    </p>
                </div>

            </div>
        </div>

        <div class="form-group mb-4">
            <label>
                <strong>
                    Calculated Price
                </strong>
            </label>
            <div class="input-group">
                <span class="input-group-text">&pound;</span>
                <input
                    class="form-control"
                    placeholder="0.00"
                    name="price"
                    v-model="internalCalculatedPrice"
                    type="text"
                    id="price">
            </div>
        </div>

        <div class="form-group mb-4">
            <label>
                <strong>
                    Current Price
                </strong>
            </label>
            <div class="input-group">
                <span class="input-group-text">&pound;</span>
                <input
                    class="form-control"
                    placeholder="0.00"
                    name="price"
                    v-model="internalCurrentPrice"
                    type="text"
                    id="price"
                    disabled="disabled"
                >
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="checkbox checkbox-primary">
                    <input
                        type="checkbox"
                        id="price_includes_fuel"
                        name="price_includes_fuel"
                        v-model="priceIncludesFuel"
                    />
                    <label for="price_includes_fuel">
                        Price Includes Fuel
                    </label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="checkbox checkbox-primary">
                    <input
                        type="checkbox"
                        id="price_includes_adblue"
                        name="price_includes_adblue"
                        v-model="priceIncludesAdblue"
                    />
                    <label for="price_includes_adblue">
                        Price Includes Adblue
                    </label>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";

    export default {

        props: {
            contract_id: {
                type: Number,
                required: false,
                default: null,
            },
            vehicle_id: {
                type: Number,
                required: false,
                default: null,
            },
            mileage : {
                type: Number,
                required: false,
                default: 0,
            },
            price: {
                type: Number | String,
                required: false,
                default: 0,
            },
            fuel: {
                type: Boolean,
                required: false,
                default: false,
            },
            adblue: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {

                internalContractId: this.contract_id,
                internalVehicleId: this.vehicle_id,
                internalMileage: this.mileage,

                rate: null,
                rate_information: null,

                internalCurrentPrice: this.price,
                internalCalculatedPrice: this.price,

                priceIncludesFuel: this.fuel,
                priceIncludesAdblue: this.adblue,

            }
        },

        mounted() {
            this.getPrice();
        },

        methods: {

            getPrice() {

                if ( this.internalContractId === null || this.internalVehicleId === null || this.internalMileage === 0 ) {
                    return;
                }

                let formData = new FormData();

                formData.append('contract_id', this.internalContractId);
                formData.append('vehicle_id', this.internalVehicleId);
                formData.append('mileage', this.internalMileage);

                axios.post(route('api.movements.jobs.getPrice'), formData )
                    .then(response => {

                        this.rate = response.data.rate;
                        this.rate_information = response.data.rate_information;

                        this.internalCalculatedPrice = response.data.rate.total;

                        this.$emit('update-price', {
                            'price': this.internalCalculatedPrice,
                            'rate': this.rate,
                            'rate_information': this.rate_information,
                            'price_includes_fuel': this.priceIncludesFuel,
                            'price_includes_adblue': this.priceIncludesAdblue,
                        });

                    })
                    .catch( error => {

                        const errorMessages = error.response.data.errors;

                        let allErrors = '';

                        Object.entries(errorMessages).forEach(([, messages]) => {
                            messages.forEach(errorMessage => {
                                allErrors += '<p class="mb-0">' + errorMessage + '</p>';
                            });
                        });

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'error',
                            title: 'Error Generating Price',
                            html: allErrors,
                            confirmButtonText: 'Dismiss',
                            confirmButtonColor: '#dc3545 ',
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer);
                                toast.addEventListener('mouseleave', Swal.resumeTimer);
                            },
                        });

                    });

            },

        },

        watch: {
            contract_id: function(val) {
                this.internalContractId = val;
            },
            internalContractId: function() {
                this.getPrice();
            },
            vehicle_id: function(val) {
                 this.internalVehicleId= val;
            },
            internalVehicleId: function() {
                this.getPrice();
            },
            mileage: function(val) {
                this.internalMileage = val;
            },
            internalMileage: function() {
                this.getPrice();
            },
            price: function (val) {
                this.internalCurrentPrice = val;
            },
            internalCalculatedPrice: function() {
                this.$emit('update-price-only', this.internalCalculatedPrice);
            },
            priceIncludesAdblue: function() {
                this.$emit('update-adblue', this.priceIncludesAdblue);
            },
            priceIncludesFuel: function() {
                this.$emit('update-fuel', this.priceIncludesFuel);
            },
        }

    }
</script>
